<template>
    <v-ons-list-item class="outlets-list-item pressable"
        v-on:click="$router.push({ name: 'Menu', params: { outlet_slug: outlet.slug } })"
        tappable>
        <div class="center">
            <div class="row">
                <div class="col-xs-9 outlets-list-item-header">
                    <div class="outlet-info-line outlet-name-text">{{ outlet.store_display_name }}</div>
                    <div class="outlet-info-line outlet-tag-text">
                        <template v-if="outlet.store_is_offline">
                            Not currently accepting orders
                        </template>
                        <template v-else>
                            {{ outlet.opening_times_info.status }}
                        </template>
                    </div>
                    <div class="outlet-info-line outlet-tag-text">
                        <template  v-if="outlet.tags.length > 0">
                            {{ outlet.tags.map(t => filters.capitalise(t)).join(' • ') }}
                        </template>
                        <template v-else>No tags</template>
                    </div>
                    <div class="outlet-info-line outlet-tag-text">
                        {{ outlet.order_fulfillment_type_names.join(' • ') }}
                        <br>
                    </div>
                </div>
                <div class="col-xs-3 flex-center">
                    <div class="outlet-logo" v-show="outlet.logo_image">
                        <img class="list-item__thumbnail" v-bind:src="outlet.logo_image">
                    </div>
                </div>
            </div>
            <div class="outlet-info-btns">
                <div class="outlet-info-btn" v-if="outlet.prep_time_minutes_min > 0">
                    <gtc-button class="tertiary small" icon="fal fa-shopping-basket">
                        ~{{ helpers.outletPrepTimeShort(outlet.prep_time_minutes_min) }}
                    </gtc-button>
                </div>
                <div class="outlet-info-btn" v-if="show_distance">
                    <gtc-button class="tertiary small" icon="fal fa-map-marker-check">
                        ~{{ filters.roundUp(outlet.distance_miles * 1.20) }} miles
                    </gtc-button>
                </div>
                <div class="outlet-info-btn">
                    <gtc-button class="tertiary small" v-if="outlet.opening_times_info" icon="fal fa-clock">
                        {{ outlet.opening_times_info.is_open && outlet.store_is_offline == false ? 'Open' : 'Closed' }}
                    </gtc-button>
                </div>
            </div>
        </div>
    </v-ons-list-item>
</template>

<script>
    export default {
        name: "outlet_list_item",

        props: ['outlet', 'show_distance'],
    }
</script>

<style scoped>
    .outlets-list ons-list-item {
        background-color: #fff;
    }

    .outlets-list-item-header {
        padding: 0px;
    }

    .outlet-info-line {
        margin-bottom: 5px;
    }
</style>


// WEBPACK FOOTER //
// src/js/components/fragments/outlet_list_item.vue